import { observer } from 'mobx-react';
import { NotTranslated, T } from '../../../../../../Translations';
import FlashError from '../../../../../FlashMessage/FlashError';
import {
  whenExceededMaxUsers,
  whenNoUsersSelected,
} from '../../../../Participants/BulkActions/AllocateLicenseToParticipants/Types';
import { LoadingError } from '.././Types';

interface Props {
  state: LoadingError;
}

function LoadingErrorView({ state }: Props) {
  switch (state.error.kind) {
    case 'invalid-form-values':
      const error = state.error;
      return whenExceededMaxUsers(error)
        .map((maxUsers) => (
          <FlashError>
            <T
              kind="You may allocate a license to up to {{maxUsers}} users at a time..."
              maxUsers={maxUsers}
            />
          </FlashError>
        ))
        .orElse(() =>
          whenNoUsersSelected(error).map(() => (
            <FlashError>
              <T kind="This group has no participants..." />
            </FlashError>
          )),
        )
        .getOrElse(() => (
          <FlashError>
            <T kind="Error Loading." /> <NotTranslated text={state.error.kind} />
          </FlashError>
        ));
    case 'bad-url':
    case 'timeout':
    case 'network-error':
    case 'bad-status':
    case 'bad-payload':
    case 'missing-application-id':
    case 'missing-api-compatibility':
    case 'missing-template-error':
    case 'missing-link-error':
    case 'missing-field-error':
      return (
        <FlashError>
          <T kind="Error Loading." /> <NotTranslated text={state.error.kind} />
        </FlashError>
      );
  }
}

export default observer(LoadingErrorView);
